import {
  CorrespondentRemittanceActionTypes,
  CorrespondentRemittanceState,
  FETCH_CORRESPONDENT_FAILURE,
  FETCH_CORRESPONDENT_REQUEST,
  FETCH_CORRESPONDENT_SUCCESS
} from '../../actions/correspondent/types';

const initialState: CorrespondentRemittanceState = {
  data: null,
  loading: false,
  error: null,
};

const correspondentRemittanceReducer = (
  state: CorrespondentRemittanceState = initialState,
  action: CorrespondentRemittanceActionTypes
): CorrespondentRemittanceState => {
  switch (action.type) {
    case FETCH_CORRESPONDENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CORRESPONDENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case FETCH_CORRESPONDENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: null,
      };
    default:
      return state;
  }
};

export default correspondentRemittanceReducer;